import { useState, useEffect } from 'react'
import { useFollows } from '../hooks/useFollows'
import { supabase } from '../lib/supabase'
import { postFn } from '../lib/postFn'
import { Avatar } from './Avatar'

export function SendToFriendList({ show, user, msg, onMsgChange, onSent }) {
  const [following, setFollowing] = useState([])
  const [sending,   setSending]   = useState(null) // userId being sent to
  const [sent,      setSent]      = useState(new Set())

  const { followingIds: _follows } = useFollows(user?.id)

  useEffect(() => {
    if (!user?.id || !_follows.length) return
    const ids = _follows
    supabase.from('profiles').select('id,display_name,username').in('id', ids)
      .then(({ data }) => setFollowing(data || []))
  }, [user?.id, _follows.length])

  const send = async (toUser) => {
    if (sent.has(toUser.id)) return
    setSending(toUser.id)
    await supabase.from('recommendations').insert({
      from_user:   user.id,
      to_user:     toUser.id,
      show_id:     show.id,
      show_name:   show.name,
      show_poster: show.poster_path,
      message:     msg?.trim() || null,
    })
    // Also write an activity for this
    await supabase.from('activities').insert({
      user_id:    user.id,
      type:       'recommended',
      show_id:    show.id,
      show_name:  show.name,
      show_poster:show.poster_path,
      data:       { to_user: toUser.id, to_username: toUser.username, message: msg?.trim(), public: false },
      created_at: new Date().toISOString(),
    })
    // Trigger push notification to recipient
    postFn('/.netlify/functions/notify-activity', {
      type: 'recommended',
      show: { id: show.id, name: show.name, poster_path: show.poster_path },
      extra: { to_user: toUser.id, message: msg?.trim() || null },
    }).catch(() => {})

    setSent(prev => new Set([...prev, toUser.id]))
    setSending(null)
    if (following.length === 1 || sent.size + 1 === following.length) onSent?.()
  }

  if (following.length === 0) {
    return (
      <div style={{ textAlign:'center', padding:'24px 0', color:'var(--text-muted)', fontSize:13 }}>
        Follow people to send them recommendations
      </div>
    )
  }

  return (
    <>
      {/* Optional message */}
      <input
        value={msg}
        onChange={e => onMsgChange(e.target.value)}
        placeholder="Add a note... (optional)"
        style={{ width:'100%', padding:'9px 12px', background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-sm)', color:'var(--text)', fontSize:16, boxSizing:'border-box', fontFamily:'var(--font)', marginBottom:12 }}
      />

      {/* Friend list */}
      <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
        {following.map(f => {
          const isSent    = sent.has(f.id)
          const isSending = sending === f.id
          return (
            <div key={f.id} style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 12px', background:'var(--bg-card)', borderRadius:'var(--radius)', border:'1px solid var(--border)' }}>
              <Avatar name={f.display_name || f.username || '?'} avatarUrl={f.avatar_url} size={38} />
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ color:'var(--text)', fontWeight:600, fontSize:14 }}>{f.display_name || f.username}</div>
                {f.username && f.display_name && <div style={{ color:'var(--amber)', fontSize:11 }}>@{f.username}</div>}
              </div>
              <button
                onClick={() => send(f)}
                disabled={isSent || isSending}
                style={{
                  background: isSent ? 'color-mix(in srgb, var(--state-good) 15%, transparent)' : 'color-mix(in srgb, var(--accent) 15%, transparent)',
                  border: `1px solid ${isSent ? 'color-mix(in srgb, var(--state-good) 30%, transparent)' : 'color-mix(in srgb, var(--accent) 30%, transparent)'}`,
                  borderRadius:'var(--radius-xl)', padding:'6px 14px',
                  color: isSent ? 'var(--green)' : 'var(--purple)',
                  fontWeight:600, fontSize:12, cursor: isSent ? 'default' : 'pointer',
                  fontFamily:'var(--font)', flexShrink:0,
                }}>
                {isSending ? '…' : isSent ? '✓ Sent' : 'Send'}
              </button>
            </div>
          )
        })}
      </div>
    </>
  )
}
